// import { loadStripe } from '@stripe/stripe-js'; // <- Remove this static import
import { getStripePublicKey } from '@/api/base';
import store from '@/store';
import Vue from 'vue';

export async function stripeInit() {
  const isSaas = store.getters['common/isSaas'];

  if (!isSaas) {
    return;
  }

  const { publishableKey } = await getStripePublicKey();

  if (!publishableKey) {
    throw new Error('Missing Publishable Key');
  }

  // Dynamically import loadStripe when needed
  const { loadStripe } = await import('@stripe/stripe-js');

  return loadStripe(publishableKey).then((stripe) => {
    Vue.prototype.$stripe = stripe;

    return stripe;
  });
}
